import { WatchedLoadModel } from '../../models/home/WatchedLoads.model';
import { ToastMessage } from '../../utils/ToastMessage';
import * as Constants from '../../utils/constants';
import { EVENT, SCREEN, TAB } from '../../utils/constants.analytics';
import { logEvent } from '../../utils/Analytics';

export const toggleWatchLoad = (props: any) => (loadId: string, loadDetails: any, status = false) => {
    const { memberDetailsResponse } = props.userDetails;
    const locate = props.location && props.location.pathname;
    if (!props.isNetworkAvailable) {
        props.showAlert({
            isShowAlert: true,
            alertMessage: Constants.PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
            alertTitle: Constants.NO_NETWORK,
        });
        return true;
    }
    const watchDate = new Date().toISOString();
    const payload = {
        carrierId: memberDetailsResponse && memberDetailsResponse.member && memberDetailsResponse.member.carrierId,
        userId :memberDetailsResponse && memberDetailsResponse.member &&  memberDetailsResponse.member.upn,
        origin: "",
        loadId,
        watchDate,
    };
    const watchLoadModel = new WatchedLoadModel();
    if (!status) {
        props.addWatchLoad({
            query: watchLoadModel.addWatchLoad(payload),
            loadDetails,
        });
        ToastMessage.open({
            message: Constants.WATCHED_LOAD_ADDED,
        });
        // Analytics implementation
        logEvent(EVENT.UE_WATCH_LOAD, {
            screen: SCREEN.LOAD_DETAILS,
            loadId,
            carrierId :memberDetailsResponse && memberDetailsResponse.member && memberDetailsResponse.member.carrierId,
            lead: locate && locate.indexOf(Constants.MODULES.SEARCH_RESULTS) > -1 ? TAB.SEARCHED : TAB.RECOMMENDED
        });
    } else {
        const watchLoadCallback = () =>
            props.addWatchLoad({
                query: watchLoadModel.addWatchLoad(payload),
                loadDetails,
            });
        const callback = (error: boolean = false) => {
            if (error) {
                ToastMessage.show(Constants.watchedErrorText);
                return true;
            }
            ToastMessage.open({
                message: Constants.WATCHED_LOAD_REMOVE,
                showUndo: true,
                callback: watchLoadCallback,
            });
        };
        props.removeWatchLoad({
            query: watchLoadModel.removeWatchLoad(payload),
            loadId,
            callback,
        });
    }

};